
export const dateFormatter = (date) => {
    const d = new Date(date); // si 'date' est déjà un Date, pas de conversion nécessaire

    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0'); // mois indexés à 0
    const year = d.getFullYear();

    return `du ${day}/${month}/${year}`;
}
